import addBusinessDays from "date-fns/addBusinessDays"
import addHours from "date-fns/addHours"
import getHours from "date-fns/getHours"
import isBefore from "date-fns/isBefore"
import isWeekend from "date-fns/isWeekend"
import max from "date-fns/max"
import min from "date-fns/min"
import parseISO from "date-fns/parseISO"
import setHours from "date-fns/setHours"
import startOfDay from "date-fns/startOfDay"

import differenceInBusinessDays from "date-fns/differenceInBusinessDays"

import cloneDeep from "lodash.clonedeep"

import { durToHours, hoursToDur } from "../timeHandler/durations"
import { spentExtrapolate } from "../utils/mathHelper"

import { DAY_END, DAY_START, ROOT, HOURS_PER_DAY } from "../../const/globals"

// TODO: need to be revamped
import { dateAddDuration } from "../../functions/timeHandler/timeHandler"

// import { deepDiff } from "../utils/deepDiff"

// completionAccPipe
// nodesDeadlinePipe
// nodesStatusAcc

// HELPERS =================================================================

/**
 * (c) Jasper Anders
 * (c) Prof. Dr. Ulrich Anders
 *
 * Adds one hour to a date, respecting DAY_START and DAY_END
 * @param {string} isoDate
 * @returns {date dateAdded
 */
export function isoDateOneHourAdd(
  isoDate,
  businessDayStart = DAY_START,
  businessDayEnd = DAY_END
) {
  let dateAdded = addHours(parseISO(isoDate), 1)
  if (getHours(dateAdded) >= businessDayEnd || isWeekend(dateAdded)) {
    dateAdded = addBusinessDays(dateAdded, 1)
    dateAdded = startOfDay(dateAdded)
    dateAdded = setHours(dateAdded, businessDayStart)
  }
  return dateAdded
}

/**
 * (c) Jasper Anders
 * TEST: ok
 *
 * Returns the sum of durations that are in an array
 * @param {array of strings} durationsArray
 * @return {int} hoursPerDay
 * @return {int} sum
 */
export function durationsArraySumCalc(
  durationsArray,
  hoursPerDay = HOURS_PER_DAY
) {
  let sum = { days: 0, hours: 0 }
  durationsArray.forEach((element) => {
    sum.hours += element.hours
    sum.days += element.days + Math.floor(sum.hours / hoursPerDay)
    sum.hours = sum.hours % hoursPerDay
  })
  return sum
}

/**
 * (c) Prof. Dr. Ulrich Anders
 *
 * Returns the minimum int from an array keeping only numbers > 0
 * @param {*} arr
 * @return {int} min
 */
export const arrFilteredMinGet = (arr) => {
  const arrFiltered = arr.filter((num) => num > 0)
  let min = 0
  if (arrFiltered.length > 0) {
    min = Math.min(...arrFiltered)
  }
  return min
}

/**
 * (c) Prof. Dr. Ulrich Anders
 *
 * Returns the minimum of two isoDates strings.
 * An isoDate === "" is eternity.
 * @param {string} isoDate1
 * @param {string} isoDate2
 * @returns {boolean} isBefore
 */
export function isBeforeISO(isoDate1, isoDate2) {
  if (isoDate1 === "" && isoDate2 === "") {
    return false
  } else if (isoDate2 === "") {
    return true
  } else if (isoDate1 === "") {
    return false
  }

  const date1 = parseISO(isoDate1)
  const date2 = parseISO(isoDate2)

  const temp = isBefore(date1, date2)

  // console.log(isoDate1, isoDate2, temp)

  return temp
}

/**
 * (c) Prof. Dr. Ulrich Anders
 *
 * Returns the minimum of two isoDates strings
 * @param {string} isoDate1
 * @param {string} isoDate2
 * @returns {string} minIsoDate
 */
export function minISO(isoDate1, isoDate2) {
  let minIsoDate = ""
  if (isoDate1 === "" && isoDate2 === "") {
    return minIsoDate
  } else if (isoDate1 === "" || isoDate2 === "") {
    return isoDate1 + isoDate2
  }

  const date1 = parseISO(isoDate1)
  const date2 = parseISO(isoDate2)

  minIsoDate = min([date1, date2]).toISOString()

  return minIsoDate
}

/**
 * (c) Prof. Dr. Ulrich Anders
 * STATUS: NOT NEEDED
 *
 * Returns the maximum of two isoDates strings
 * @param {string} isoDate1
 * @param {string} isoDate2
 * @returns {string} maxIsoDate
 */
export function maxISO(isoDate1, isoDate2) {
  let maxIsoDate = ""
  if (isoDate1 === "" && isoDate2 === "") {
    return maxIsoDate
  } else if (isoDate1 === "" || isoDate2 === "") {
    return isoDate1 + isoDate2
  }

  const date1 = parseISO(isoDate1)
  const date2 = parseISO(isoDate2)

  maxIsoDate = max([date1, date2]).toISOString()

  return maxIsoDate
}

// GOING DOWN & INHERIT STATE ====================================================

/**
 * (c) Prof. Dr. Ulrich Anders
 *
 * Cleans and mutates the nodes[nId].precedents, nodes[pId].dependents,
 * and nodes[nId].precedents[precedent].dependents
 * Removes:
 * - precedent that is the parent
 * - precedents that are already precedents in the parent
 * @param {object} nodes
 * @param {string} nId
 * @returns {object} nodes
 */
export function nodeDependenciesClean(nodes, nId) {
  const { pId } = nodes[nId]

  console.log({ nId: nodes[nId], pId: nodes[pId] })
  // if parent is a precedent
  if (
    nodes[nId].precedents.length > 0 &&
    nodes[nId].precedents.indexOf(pId) > -1
  ) {
    console.log("clean from daddy")
    // filter out pId in node[nId].precedents
    nodes[nId].precedents = nodes[nId].precedents.filter(
      (precedent) => precedent !== pId
    )
    // filter out nId in node[pId].dependents
    nodes[pId].dependents = nodes[pId].dependents.filter(
      (dependent) => dependent !== nId
    )
  }

  //

  if (nodes[nId].precedents.length > 0 && nodes[pId].precedents.length > 0) {
    // keep precedent only if not found in precedent of parent
    nodes[nId].precedents.forEach((precedent) => {
      if (nodes[pId].precedents.indexOf(precedent) >= -1) {
        nodes[precedent].dependents = nodes[precedent].dependents.filter(
          (dependent) => dependent !== nId
        )
      }
    })
    nodes[nId].precedents = nodes[nId].precedents.filter(
      (precedent) => nodes[pId].precedents.indexOf(precedent) === -1
    )
  }

  return nodes[nId]
}

/**
 * (c) Prof. Dr. Ulrich Anders
 *
 * Calculates and mutates fromWhenEarliest of node nId
 * inherited from fromWhenEarliest from the parent and
 * dependent on the byWhen of the precedents.
 * @param {object} nodes
 * @param {string} nId
 * @returns {object} nodes
 */
export function nodeFromWhenEarliestSet(nodes, nId) {
  const { precedents } = nodes[nId]
  const dates = []

  // TODO: this should go into the ROOT
  dates.push(parseISO(nodes[ROOT].fromWhen))

  // TODO: this should be removed when fromWhenEarliest is proper part of state
  if (nodes[nId].fromWhenEarliest === undefined) {
    nodes[nId].fromWhenEarliest = ""
  }

  // inherited from parents
  if (nodes[nId].fromWhenEarliest !== "") {
    dates.push(parseISO(nodes[nId].fromWhenEarliest))
  }

  // received from precedents
  if (precedents.length > 0) {
    precedents.forEach((precedent) => {
      // console.log("nodeFromWhenEarliestSet: ", { ...nodes[precedent] })
      dates.push(isoDateOneHourAdd(nodes[precedent].byWhen))
    })
  }

  if (dates.length > 0) {
    nodes[nId].fromWhenEarliest = max(dates).toISOString()
    // console.log("nodeFromWhenEarliestSet: ", {
    //   nId,
    //   fromWhenEarliest: nodes[nId].fromWhenEarliest,
    // })
  }
  return nodes[nId]
}

/**
 * (c) Prof. Dr. Ulrich Anders
 *
 * Recursively pulls byWhenLatest from dependents if it is smaller.
 * Helper function for nodeByWhenLatestSet()
 * @param {object} nodes
 * @param {string} nId
 * @returns {object} nodes[nId]
 */
const nodeByWhenLatestPull = (nodes, nId) => {
  const { dependents } = nodes[nId]

  // console.log("nodeByWhenLatestPull", {
  //   nId,
  //   dependents: JSON.stringify(dependents),
  // })

  dependents.forEach((dependent) => {
    // console.log("nodeByWhenLatestPull for Each", { nId, dependent })
    nodes[dependent] = nodeByWhenLatestPull(nodes, dependent)
    if (isBeforeISO(nodes[dependent].byWhenLatest, nodes[nId].byWhenLatest)) {
      nodes[nId].byWhenLatest = nodes[dependent].byWhenLatest

      // console.log("nodeByWhenLatestPull: ", { nId, dependent, msg: "pulled" })
    }
  })

  return nodes[nId]
}

/**
 * (c) Prof. Dr. Ulrich Anders
 *
 * Recursively pushes byWhenLatest to all precedent if it is smaller.
 * Helper function for nodeByWhenLatestSet()
 * @param {object} nodes
 * @param {string} nId
 * @returns {object} nodes[nId]
 */
const nodeByWhenLatestPush = (nodes, nId) => {
  const { precedents } = nodes[nId]

  // console.log("nodeByWhenLatestPush ", {
  //   nId,
  //   precedents: JSON.stringify(precedents),
  // })

  precedents.forEach((precedent) => {
    console.log("nodeByWhenLatestPush forEach", { nId, precedent })
    if (isBeforeISO(nodes[nId].byWhenLatest, nodes[precedent].byWhenLatest)) {
      nodes[precedent].byWhenLatest = nodes[nId].byWhenLatest

      // console.log("nodeByWhenLatestPush: ", { precedent, nId, msg: "pushed" })
    }
    nodes[precedent] = nodeByWhenLatestPush(nodes, precedent)
  })

  return nodes[nId]
}

/**
 * (c) Prof. Dr. Ulrich Anders
 *
 * Calculates and mutates byWhenLatest of node nId
 * inherited from fromWhenEarliest from the parent and
 * dependent on the byWhen of the dependents.
 * @param {object} nodes
 * @param {string} nId
 * @returns {object} nodes
 */
export function nodeByWhenLatestSet(nodes, nId) {
  // pull recursively byWhenLatest from all dependents
  nodes[nId] = nodeByWhenLatestPull(nodes, nId)
  // push byWhenLatest recursively to all precedents
  nodes[nId] = nodeByWhenLatestPush(nodes, nId)

  return nodes[nId]
}

// SET STATE ===============================================================

/**
 * (c) Prof. Dr. Ulrich Anders
 * TODO: now
 *
 * Mutates fromWhen and byWhen of node nId and re-calculates node.span if necessary
 * fromWhen depending on:
 *   - fromWhenEarliest inherited from the parent or because of precedents
 * depending on:
 *   - byWhenLatest inherited from the parent
 *   - byWhenPinned from the node itself
 * @param {object} nodes
 * @param {string} nId
 * @returns {object} nodesNew
 */
export function nodeFromByWhenSet(node) {
  const fromWhenPrevious = node.fromWhen
  const byWhenPrevious = node.byWhen
  const datesFromWhen = []
  const datesByWhen = []

  // fromWhen ---
  // TODO: this should be removed when fromWhenEarliest is proper part of state
  if (node.fromWhenEarliest === undefined) {
    node.fromWhenEarliest = ""
  }

  if (node.fromWhenEarliest !== "") {
    datesFromWhen.push(parseISO(node.fromWhenEarliest))
  }

  datesFromWhen.push(parseISO(node.fromWhen))

  if (datesFromWhen.length > 1) {
    node.fromWhen = max(datesFromWhen).toISOString()
  }

  // byWhen ---
  if (node.isByWhenPinned) {
    node.byWhenLatest = minISO(node.byWhen, node.byWhenLatest)

    // console.log("nodeFromByWhenSet: ", {
    //   nId: node.nId,
    //   byWhenLatest: node.byWhenLatest,
    // })
  }
  // TODO: RESET?
  // else {}

  if (node.byWhenLatest !== "") {
    datesByWhen.push(parseISO(node.byWhenLatest))
  }

  // TODO: dateAddDuration → dateDurationAdd
  datesByWhen.push(dateAddDuration(parseISO(node.fromWhen), node.span))

  node.byWhen = min(datesByWhen).toISOString()

  if (node.fromWhen !== fromWhenPrevious || node.byWhen !== byWhenPrevious) {
    node = nodeSpanSet(node)
  }

  return node
}

/**
 * (c) Ulrich Anders
 *
 * Mutates the node and sets the span based on
 * byWhen and fromWhen.
 * It returns the node itself.
 * @param {object} node
 * @param {string} nId
 * @param {object} node
 */
export function nodeSpanSet(
  node,
  businessDayStart = DAY_START,
  businessDayEnd = DAY_END
) {
  const { byWhen, fromWhen } = node
  const byWhenDate = parseISO(byWhen)
  const fromWhenDate = parseISO(fromWhen)

  let businessDays = differenceInBusinessDays(byWhenDate, fromWhenDate)

  const hoursDiff = getHours(byWhenDate) - getHours(fromWhenDate)
  let hours = hoursDiff

  if (getHours(fromWhenDate) + hoursDiff > businessDayEnd) {
    const hoursRest = hours - businessDayEnd
    businessDays += 1
    hours = hoursRest
  } else if (getHours(fromWhenDate) + hoursDiff <= businessDayStart) {
    const hoursRest = businessDayEnd - (businessDayStart - hours)
    businessDays -= 1
    hours = hoursRest
  }

  node.span = {
    days: businessDays ? businessDays : 0,
    hours: hours ? hours : 0,
  }

  // TODO: span any byWhenFct are the same.
  node.byWhenFct = cloneDeep(node.span)

  return node
}

/**
 * (c) Prof. Dr. Ulrich Anders
 *
 * Mutates the node and sets projection and slack value.
 * Note that span and spent should already be set.
 * @param {*} node
 * @returns {object} node
 */
export const nodeProjectionSlackSet = (node) => {
  node.projection = spentExtrapolate(node.spent, node.degree)
  // initially the projection is set to the span
  if (node.projection.days === 0 && node.projection.hours === 0) {
    node.projection = cloneDeep(node.span)
  }
  if (node.isIgnored) {
    node.projection = cloneDeep(node.spent)
  }

  const hoursSpan = durToHours(node.span)
  const hoursProjection = durToHours(node.projection)
  node.slack = hoursToDur(hoursSpan - hoursProjection)

  return node
}

/**
 * (c) Prof. Dr. Ulrich Anders
 *
 * Mutates the node and sets the Deadline Traffic Light
 * and sets forecast and quality Traffic Lights accordingly
 * @param {*} node
 * @param {*} dId
 * @returns
 */
export const nodeTrafficLightsSet = (node, dId) => {
  const { byWhen, degree } = node

  const isByWhenBeforeStatus = isBefore(parseISO(byWhen), parseISO(dId))

  if (degree >= 100) {
    node.deadline = 4 // green
    node.forecast = 0
  }
  // < 100%
  else {
    if (isByWhenBeforeStatus) {
      node.deadline = 1 // red
      node.forecast = 0
      node.quality = 0
    } else {
      node.deadline = 0
      node.quality = 0
    }
  }
  return node
}

// AGGregat STATE ===============================================================

/**
 * (c) Prof. Dr. Ulrich Anders
 * TODO: no isPinned
 *
 * Mutates the nodes[nId] and aggregates byWhen and fromWhen.
 * @param {object} nodes
 * @param {string} nId
 * @returns {object} nodes[nId]
 */
export function nodeFromByWhenAgg(nodes, nId) {
  const children = nodes[nId].children
  const childrenWithout = children.filter(
    (child) => !nodes[child].isIgnored || !nodes[child].isUnresolved
  )

  if (childrenWithout.length > 0) {
    let fromWhenDates = childrenWithout.map((child) =>
      parseISO(nodes[child].fromWhen)
    )
    let byWhenDates = childrenWithout.map((child) =>
      parseISO(nodes[child].byWhen)
    )

    nodes[nId].fromWhen = min(fromWhenDates).toISOString()
    nodes[nId].byWhen = max(byWhenDates).toISOString()
  }

  return nodes[nId]
}

/**
 * (c) Prof. Dr. Ulrich Anders
 * TODO: no isPinned
 *
 * Mutates the nodes[nId] and aggregates projection and spent.
 * @param {object} nodes
 * @param {string} nId
 * @returns {object} nodes[nId]
 */
export function nodeProjectionSpentDegreeAgg(nodes, nId) {
  const children = nodes[nId].children
  const childrenWithout = children.filter(
    (child) => !nodes[child].isIgnored || !nodes[child].isUnresolved
  )

  if (childrenWithout.length > 0) {
    const projections = childrenWithout.map((child) => nodes[child].projection)
    const spents = childrenWithout.map((child) => nodes[child].spent)
    const isSomeChildrenDegree = childrenWithout.some(
      (child) => nodes[child].degree > 0
    )

    nodes[nId].projection = durationsArraySumCalc(projections)
    nodes[nId].spent = durationsArraySumCalc(spents)
    nodes[nId].degree = 0

    const hoursProjection = durToHours(nodes[nId].projection)

    if (hoursProjection > 0 && isSomeChildrenDegree > 0) {
      const hoursSpent = durToHours(nodes[nId].spent)
      nodes[nId].degree = Math.round((hoursSpent / hoursProjection) * 100)
    }
  }

  return nodes[nId]
}

/**
 * (c) Prof. Dr. Ulrich Anders
 * TODO: no isPinned
 *
 * Mutates the nodes[nId] and aggregates projection and spent.
 * @param {object} nodes
 * @param {string} nId
 * @returns {object} nodes[nId]
 */
export function nodeTrafficLightsAgg(nodes, nId) {
  const children = nodes[nId].children
  const childrenWithout = children.filter(
    (child) => !nodes[child].isIgnored || !nodes[child].isUnresolved
  )

  if (childrenWithout.length > 0) {
    const deadlines = childrenWithout.map((child) => nodes[child].deadline)
    const forecasts = childrenWithout.map((child) => nodes[child].forecast)
    const qualities = childrenWithout.map((child) => nodes[child].quality)

    nodes[nId].deadline = arrFilteredMinGet(deadlines)
    nodes[nId].forecast = arrFilteredMinGet(forecasts)
    nodes[nId].quality = arrFilteredMinGet(qualities)
  }

  return nodes[nId]
}

//========================================================================

/**
 * (c) Prof. Dr. Ulrich Anders
 *  WIP: go down from nId go back up to ROOT
 *
 * A function that generically runs through the node tree starting at nId
 * and performs all state actions going down
 * and carrying out all aggregations coming back up again
 * @param {object} nodes
 * @param {string} nId
 * @param {object} options
 * @returns {object} nodesNew
 */
export function nodesTreeDownUp(
  nodes,
  nId = ROOT,
  dId,
  options = {
    doPositions: true,
    doDependenciesClean: true,
    doFromByWhens: true,
    doTrafficLights: true,
    doEarliestLatest: true,
  }
) {
  // console.log("nodesTreeDownUp: ", nId)
  const {
    doPositions,
    doDependenciesClean,
    doFromByWhens,
    doTrafficLights,
    doEarliestLatest,
  } = options

  const nodesNew = nodes
  // Extract properties of a node
  const node = nodes[nId]
  const { children } = node
  // check if node has children
  if (children.length > 0) {
    // GO DOWN
    node.children.forEach((child, index) => {
      if (doPositions) {
        nodesNew[child].position = [...nodesNew[nId].position, index + 1]
      }

      if (doDependenciesClean) {
        nodesNew[child] = nodeDependenciesClean(nodesNew, child)
      }

      if (doEarliestLatest) {
        // INHERITANCE from parents
        nodesNew[child].fromWhenEarliest = nodesNew[nId].fromWhenEarliest
        nodesNew[child].byWhenLatest = nodesNew[nId].byWhenLatest
        // consider fromWhenEarliest resulting from precedents
        nodesNew[child] = nodeFromWhenEarliestSet(nodes, child)
        // consider byWhenLatest resulting from precedents
        nodesNew[child] = nodeByWhenLatestSet(nodes, child)
      }

      // RECURSION: trigger stateCalc in each child
      nodesNew[child] = nodesTreeDownUp(nodesNew, child)[child]
    })
    // COME BACK UP
    // AGGREGATE over children

    if (doFromByWhens || doEarliestLatest) {
      nodesNew[nId] = nodeFromByWhenAgg(nodesNew, nId)
      nodesNew[nId] = nodeSpanSet(nodesNew[nId])
      nodesNew[nId] = nodeProjectionSpentDegreeAgg(nodesNew, nId)
      // slack is never aggregated and therefore set to { days: 0, hours: 0 }
      nodesNew[nId].slack = { days: 0, hours: 0 }
    }

    if (doTrafficLights) {
      nodesNew[nId] = nodeTrafficLightsAgg(nodesNew, nId)
    }

    return nodesNew
  }

  // STATE SETTINGS: carry out at leaf level
  if (doFromByWhens || doEarliestLatest) {
    nodesNew[nId] = nodeSpanSet(nodesNew[nId])
    nodesNew[nId] = nodeFromByWhenSet(nodesNew[nId])
    nodesNew[nId] = nodeProjectionSlackSet(nodesNew[nId])
  }
  if (doTrafficLights) {
    nodesNew[nId] = nodeTrafficLightsSet(nodesNew[nId], dId)
  }

  return nodesNew
}
